<app-cp-reports-month-viewer></app-cp-reports-month-viewer>
<app-cp-reports-explanatory-factors></app-cp-reports-explanatory-factors>